import { TextField, Autocomplete, SvgIcon, Icon, Button, DialogContent, DialogTitle, Dialog } from "@mui/material";
import { AIIcon } from "components/_Icons/AIIcon";
import DirectIcon from "components/_Icons/DirectIcon";
import { CommentIcon } from "components/_Icons/CommentIcon";
import React, { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FaPlus } from "react-icons/fa";
import { toast } from "react-toastify";
import TriggerEditForm from "./TriggerEditForm";



const icons = (icon: string) => {
  switch (icon) {
    case "DIRECT":
      return <DirectIcon />;
    case "AI":
      return <AIIcon />;
    case "COMMENT":
      return <CommentIcon />;
    default:
      return null;
  }
}

interface AutomationTriggerV2Props {
  triggerTypes: any;
}

const AutomationTriggerV2 = ({ triggerTypes }: AutomationTriggerV2Props) => {
  const { setValue, getValues, control, register, resetField, watch } = useFormContext();

  const [selectedTrigger, setSelectedTrigger] = useState<any>(null);

  // Выборка триггера
  const [openSelectTriggerDialog, setOpenSelectTriggerDialog] = useState(false);
  // Настройки триггера
  const [openTriggerSettingsDialog, setOpenTriggerSettingsDialog] = useState(false);

  const selectTrigger = (trigger: any) => {
    const prevTriggers = getValues("automationTriggers");

    if (prevTriggers.find((t: any) => t.triggerTypeID === trigger.id)) {
      toast.error("Триггер уже добавлен");
      return;
    }

    setValue("automationTriggers",
      [...prevTriggers,
      {
        triggerTypeID: trigger.id,
        triggerType: trigger
      }
      ], {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    setOpenSelectTriggerDialog(false);
  }

  // Обработчик настроек триггера
  const onEditTrigger = (automationTrigger: any) => {
    setSelectedTrigger(automationTrigger);
    setOpenTriggerSettingsDialog(true);
  }

  const onCloseTriggerSettingsDialog = () => {
    setOpenTriggerSettingsDialog(false);
    setSelectedTrigger(null);
  }

  const onSaveTrigger = (automationTrigger: any) => {
    console.log("automationTrigger", automationTrigger);
    const prevTriggers = getValues("automationTriggers");
    const updatedTriggers = prevTriggers.map((t: any) => {
      if (t.triggerTypeID === automationTrigger.triggerTypeID) {
        return {
          ...t,
          settings: automationTrigger.settings
        };
      }
      return t;
    });

    setValue("automationTriggers", updatedTriggers, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });

    onCloseTriggerSettingsDialog();
  }

  const onDeleteTrigger = () => {
    const prevTriggers = getValues("automationTriggers");
    const updatedTriggers = prevTriggers.filter((t: any) => t.triggerTypeID !== selectedTrigger.triggerTypeID);
    setValue("automationTriggers", updatedTriggers, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    onCloseTriggerSettingsDialog();
  }

  const buildTriggerSettingsPreview = (automationTrigger: any) => {
    const settings = automationTrigger.settings || {}
    const triggerType = triggerTypes.find((t: any) => t.id === automationTrigger.triggerTypeID);
    if (!triggerType) {
      return null;
    }
    const fields = triggerType.schema.fields;
    return fields.map((field: any) => {
      const value = settings[field.key];
      if (!value) {
        return null;
      }
      if (field.type === "string") {
        return <div key={field.key}>{field.label}: <strong>{value}</strong></div>;
      }
      if (field.type === "number") {
        return <div key={field.key}>{field.label}: <strong>{value}</strong></div>;
      }
      if (field.type === "boolean") {
        return <div key={field.key}>{field.label}: <strong>{value ? "Да" : "Нет"}</strong></div>;
      }
      if (field.type === "string[]") {
        return <div key={field.key}>{field.label}: <strong>{value.join(", ")}</strong></div>;
      }
      return null;
    });
  }

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="grid gap-2">
        {getValues("automationTriggers").map((automationTrigger: any) => (
          <div key={automationTrigger.triggerTypeID}
            className="flex items-center gap-2 border border-gray-200 p-2 rounded-md cursor-pointer"
            onClick={() => onEditTrigger(automationTrigger)}>
            <div className="flex items-center gap-2 w-100">
              <div>
                {automationTrigger.triggerType?.icon && icons(automationTrigger.triggerType.icon)}
              </div>
              <div className="text-sm font-medium">
                <div>{automationTrigger.triggerType.name}</div>
                <div>{buildTriggerSettingsPreview(automationTrigger)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* Add trigger button   */}
      <div className="mt-8">
        <Button className="" fullWidth variant="outlined" onClick={() => setOpenSelectTriggerDialog(true)}>
          <FaPlus />
          Добавить триггер
        </Button>
      </div>

      {/* Выбор триггера */}
      <Dialog maxWidth="md" fullWidth open={openSelectTriggerDialog} onClose={() => setOpenSelectTriggerDialog(false)}>
        <DialogTitle>Выберите триггер</DialogTitle>
        <DialogContent>
          <div className="grid gap-4">
            {triggerTypes.map((trigger: any) => (
              <div key={trigger.id}
                className="flex items-center gap-2 border border-gray-200 p-2 rounded-md cursor-pointer hover:bg-gray-100"
                onClick={() => selectTrigger(trigger)}
              >
                <div>
                  {trigger.icon && icons(trigger.icon)}
                </div>
                <div className="text-sm font-medium">{trigger.name}</div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      {/* Настройки триггера */}
      <Dialog maxWidth="md" fullWidth open={openTriggerSettingsDialog} onClose={() => onCloseTriggerSettingsDialog()}>
        <DialogTitle>Настройки триггера</DialogTitle>
        <DialogContent>
          <div className="mt-4">
            <TriggerEditForm trigger={selectedTrigger} onSave={onSaveTrigger} onDelete={onDeleteTrigger} />
          </div>
        </DialogContent>
      </Dialog>

      {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
    </div >
  );
};

export default AutomationTriggerV2;
